import Input from '../../components/input/input';
import Button from '../../components/button/button';
import IllustrationForgotPassword from '../../assets/illustration-forgot-password.png';
import { Link } from "react-router-dom";
import AuthService from '../../services/auth-service';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import TranslateService from '../../services/translate-service';

export default function ForgotPassword() {

    const [email, setEmail] = useState('')
    const [isValid, setIsValid] = useState(false)
    const [feedbackError, setFeedbackError] = useState('')
    const [isSending, setIsSending] = useState(undefined)


    const isValidateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }

    const handleEmail = (event) => {
        const value = event.target.value;

        setIsValid(value ? true : false);
        setEmail(value);
    }

    const passwordRecovery = async (event) => {
        event.preventDefault();

        if (!isValidateEmail(email)) {
            setFeedbackError('Debes de ingresar un correo válido')
            return;
        }

        setFeedbackError('')

        try {
            setIsSending(true)
            await AuthService.passwordRecovery(email);
        } catch (error) {
            console.log(error)
        } finally {
            setIsSending(false)
        }

    }

    return (
        <div className="grid grid-cols-2 min-h-screen">
            <div className="bg-[#F9F8FF] relative">
                <div className='absolute left-[50%] top-[50%] w-[100%] translate-x-[-50%] translate-y-[-50%] '>
                    <img src={IllustrationForgotPassword} alt="" className="m-auto" />
                </div>
            </div>
            <div className="grid grid-cols-6 ">
                <div className="col-span-4 col-start-2 mb-14 ">
                    <div className=' mt-64'>
                        <form className='' onSubmit={passwordRecovery}>

                            <h1 className='heading-h4 mb-5'>{TranslateService.get('recovery.title')}</h1>

                            {isSending === false &&
                                <p className='mb-5'>{TranslateService.get('recovery.submited.description')}</p>
                            }

                            {(isSending === undefined || isSending === true) &&
                                <>
                                    <p className='mb-5'>{TranslateService.get('recovery.description')}</p>
                                    <Input
                                        className="mb-6"
                                        type='email'
                                        isInvalid={feedbackError !== ''}
                                        label={TranslateService.get('recovery.label.email')}
                                        placeholder='username@example.com'
                                        value={email}
                                        onChange={handleEmail}
                                        feedback={feedbackError} />

                                    <Button className="mb-6" disabled={!isValid || isSending} onClick={passwordRecovery}>
                                        {isSending && <FontAwesomeIcon icon={faSpinner} spin={true} />} {TranslateService.get('recovery.label.btn')}
                                    </Button>
                                </>
                            }

                            <div className='mb-6'>
                                <Link to="/auth/login" className='link'>{TranslateService.get('recovery.label.link')}</Link>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
